export default __webpack_public_path__ + "static/samples-0d6e4c1a82e51d2e8d396a701deec83a.png";